module.exports = __webpack_public_path__ + "assets/img/logo.6dad7adc.svg";